import dynamic from "next/dynamic";
// used by the main login page
export var DynamicSigninWidget = dynamic(function () { return import("./signin-widget"); }, {
    ssr: false
});
// used by external consumers
export { default as SigninWidget } from "./signin-widget-with-providers";
